const bundledInit = () => {
  const Selector = {
    products: 'bundled_product',
    element: 'variation',
    inputs: 'product-size__field',
    inputsDisabled: 'product-size__field--optional',
    cart: 'bundle_add_to_cart_button',
  };

  const Class = {
    active: 'variation--active',
  };

  const products: NodeListOf<HTMLElement> = document.querySelectorAll(`.${Selector.products}`);
  const inputs = Array.from(document.querySelectorAll(`.${Selector.inputs}:not(.${Selector.inputsDisabled})`));
  const checkout: HTMLButtonElement = document.querySelector(`.${Selector.cart}`);

  const checkInputs = () => {
    const check = inputs.every((element: HTMLInputElement) => element.value !== '');

    if (!checkout) return;

    checkout.disabled = true;

    if (check) {
      checkout.disabled = false;
    }
  };

  const toggleVariation = (element: HTMLElement, parent: HTMLElement) => {
    const input: HTMLSelectElement = parent.querySelector(`.${Selector.inputs}`);
    const text: string = element.innerHTML.trim();

    input.value = text;

    element.classList.add(Class.active);
  };

  const removeClass = (variations: NodeListOf<HTMLElement>) => {
    variations?.forEach((element) => element.classList.remove(Class.active));
  };

  products?.forEach((product: HTMLElement) => {
    const variations: NodeListOf<HTMLElement> = product.querySelectorAll(`.${Selector.element}`);

    variations?.forEach((variation: HTMLElement) => {
      variation.addEventListener('click', () => {
        removeClass(variations);
        toggleVariation(variation, product);
        checkInputs();
      });
    });
  });

  checkInputs();
};

export default bundledInit;
